export function checkArticleNumbers(query: string): string[] {
  try {
    const pattern = new RegExp(
      '\\b(?:' +
        '(\\d{2})' +
        '([-./])' +
        '(?:' +
        '([A-Za-z0-9]{4,8})' +
        '(?:([-./])([A-Za-z0-9]{1,5}))?' +
        '|' +
        '(\\d{5})([-./])([A-Za-z]{1,2})' +
        '|' +
        '(\\d{7,10})' +
        ')' +
        '|' +
        '(\\d{3})' +
        '([-./])' +
        '(\\d{4,7})' +
        '(?:([-./])([A-Za-z0-9]{1,9}))?' +
        ')\\b',
      'g',
    );

    const results: string[] = [];
    const matches = query.matchAll(pattern);

    for (const groups of matches) {
      if (groups[1]) {
        if (groups[3]) {
          const result = [groups[1], groups[2], groups[3], groups[4], groups[5]].filter(Boolean).join('');
          results.push(result);
        } else if (groups[6]) {
          const result = [groups[1], groups[2], groups[6], groups[7], groups[8]].filter(Boolean).join('');
          results.push(result);
        } else if (groups[9]) {
          const result = [groups[1], groups[2], groups[9]].filter(Boolean).join('');
          results.push(result);
        }
      } else if (groups[9]) {
        const result = [groups[9], groups[10], groups[11], groups[12], groups[13]].filter(Boolean).join('');
        results.push(result);
      }
    }

    return results;
  } catch (error) {
    console.error(`Error in checkArticleNumbers: ${error}`);
    return [];
  }
}

function findComplexMatch(token: string, keywordsSet: Set<string>): string | null | undefined {
  for (const keyword of keywordsSet) {
    if (keyword.startsWith(token)) {
      return keyword;
    }
  }

  const parts = token.split('-');
  if (parts.length >= 2) {
    for (let i = 1; i < parts.length; i++) {
      const shortened = parts.slice(0, i).join('-');
      const matchingKeys = Array.from(keywordsSet).filter(k => k.startsWith(shortened));
      if (matchingKeys.length === 1) {
        return matchingKeys[0];
      }
    }
  }

  return null;
}

function findSimpleMatch(token: string, keywordsSet: Set<string>): string | null | undefined {
  const directMatches = Array.from(keywordsSet).filter(k => k.startsWith(token));
  if (directMatches.length === 1) {
    return directMatches[0];
  }

  const parts = token.split('-');
  if (parts.length === 2) {
    if (parts[0] == null || parts[0] === undefined) {
      return null;
    } else {
      const prefixMatches = Array.from(keywordsSet).filter(k => k.startsWith(parts[0]));
      if (prefixMatches.length === 1) {
        return prefixMatches[0];
      }
    }
  }

  return null;
}

function findBasicMatch(token: string, keywordsSet: Set<string>): string | null | undefined {
  const matchingKeys = Array.from(keywordsSet).filter(k => k.includes(token));
  if (matchingKeys.length === 1) {
    return matchingKeys[0];
  }
  return null;
}

export function findPrefixMatchingKeyword(query: string, keywords: string[]): [string[], string] {
  try {
    const similarKeywords = new Set<string>();
    const tokens = query.split(' ');
    const modifiedTokens = [...tokens];
    const keywordsSet = new Set(keywords);

    tokens.forEach((token, index) => {
      let matchedKeyword: string | null | undefined = null;

      if (token.includes('-') && (token.split('-').length >= 2 || token.endsWith('-C'))) {
        matchedKeyword = findComplexMatch(token, keywordsSet);
      } else if (token.includes('-')) {
        matchedKeyword = findSimpleMatch(token, keywordsSet);
      } else {
        matchedKeyword = findBasicMatch(token, keywordsSet);
      }

      if (matchedKeyword) {
        similarKeywords.add(matchedKeyword);
        modifiedTokens[index] = matchedKeyword;
      }
    });

    return [Array.from(similarKeywords), modifiedTokens.join(' ')];
  } catch (error) {
    console.error(`Error in findPrefixMatchingKeyword: ${error}`);
    return [[], query];
  }
}
